
import {defineComponent, PropType} from "vue";
import Price from "../ob1/Price.vue";
import Lien from "../ob1/Lien.vue";
import {PrixDTO} from "../../../../../../generated/js/OrderingDtos";
import {PriceDetailsCashbackType, PriceDetailsDiscountType, PriceDetailsPopinDto} from "./models/PriceDetailsPopinDto";
import {ClientTag} from "./models/ClientTag";
import {formatPriceToEuros} from "../../utils/Number";

export default defineComponent({
    name: "PriceWithDetails",
    components: {
        Price,
        Lien
    },
    props: {
        price: {
            type: Object as PropType<PrixDTO>,
            required: true
        },
        priceDetailsPopin: {
            type: Object as PropType<PriceDetailsPopinDto | undefined>,
            required: false,
            default: undefined
        },
        offerIdSeo: {
            type: String,
            required: true
        },
        offerName: {
            type: String,
            required: true
        },
        trackingCategory: {
            type: String,
            required: true
        },
        isBlack: {
            type: Boolean,
            default: false
        },
        isEmbeddedDetails: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        tileBasePrice(): string | null {
            return this.priceDetailsPopin?.basePrice
                ? formatPriceToEuros(this.priceDetailsPopin.basePrice, false)
                : null;
        },
        tileTotalDiscountsAndOdrAmount(): string | null {
            return this.priceDetailsPopin?.totalDiscountsAndCashbacksAmount
                ? formatPriceToEuros(this.priceDetailsPopin.totalDiscountsAndCashbacksAmount, false)
                : null;
        },
        tileFinalPrice(): number {
            return this.priceDetailsPopin?.finalPrice ?? this.price.price;
        },
        tileFinalPricePermanent(): number | undefined {
            return this.priceDetailsPopin?.finalPricePermanent ?? this.price.initialPrice ?? undefined;
        },
        tileDuration(): number {
            return this.priceDetailsPopin?.finalPriceDuration ?? this.price.duration;
        },
        cashbackType(): PriceDetailsCashbackType | undefined {
            if (this.priceDetailsPopin) {
                if (this.priceDetailsPopin.cashbacks.some(
                    (cashback) => cashback.cashbackType === PriceDetailsCashbackType.CHEAT_CODE
                )) {
                    return PriceDetailsCashbackType.CHEAT_CODE;
                } else if (this.priceDetailsPopin.cashbacks.some(
                    (cashback) => cashback.cashbackType === PriceDetailsCashbackType.SAFER_PHONE
                )) {
                    return PriceDetailsCashbackType.SAFER_PHONE;
                } else if (this.priceDetailsPopin.cashbacks.some(
                    (cashback) => cashback.cashbackType === PriceDetailsCashbackType.OTHER
                )) {
                    return PriceDetailsCashbackType.OTHER;
                }
            }
            return undefined;
        },
        discountType(): ClientTag | undefined {
            if (this.priceDetailsPopin) {
                if (this.priceDetailsPopin.discounts.some(
                    (discount) => discount.type === PriceDetailsDiscountType.MOBILE_CLIENT
                )) {
                    return ClientTag.MOBILE_CLIENT;
                } else if (this.priceDetailsPopin.discounts.some(
                    (discount) => discount.type === PriceDetailsDiscountType.INTERNET_CLIENT
                )) {
                    return ClientTag.INTERNET_CLIENT;
                }
            }
            return undefined;
        },
        clientTagLabel(): string | undefined {
            if (this.discountType === ClientTag.MOBILE_CLIENT) {
                return "Client mobile";
            } else if (this.discountType === ClientTag.INTERNET_CLIENT) {
                return "Client internet";
            }
            return undefined;
        },
    },
    methods: {
        showDetails(): void {
            if (this.isEmbeddedDetails) {
                this.$emit('show-details');
            }
        }
    }
});
